import { Flex, FlexProps, useBreakpointValue } from '@chakra-ui/react';
import { CONTENT_TYPES } from '~/constants';
import { ContentNameType } from '~/types/content';

interface Props extends FlexProps {
  contentType: ContentNameType;
}

const PLACEHOLDER_ASPECT_RATIOS = {
  [CONTENT_TYPES.post]: 1,
  [CONTENT_TYPES.story]: 16 / 27,
  [CONTENT_TYPES.reels]: 16 / 27,
  [CONTENT_TYPES.tiktok]: 16 / 27,
  [CONTENT_TYPES.youtube]: 16 / 11,
};

export const PreviewItemPlaceholder: React.FC<Props> = ({
  contentType,
  ...props
}) => {
  const width = useBreakpointValue({ base: '48px', sm: '80px' });

  return (
    <Flex
      alignItems="center"
      data-testid="preview item placeholder"
      borderColor="currentColor"
      borderRadius="lg"
      borderStyle="dashed"
      borderWidth="1px"
      color="primary.200"
      justifyContent="center"
      width={width}
      height={`calc(${width} / ${PLACEHOLDER_ASPECT_RATIOS[contentType]})`}
      {...props}
    />
  );
};
